
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Info',

  props: {
    title: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'vanilla-400'
    }
  }
})
